import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import lobbyReducers from "../reducers"

// `handlesOwnErrors`, for the same reason `joinLobby` carries it: `FindLobbyModal` renders the
// refusal itself, in the form, where the player is looking. Without this the interceptor added
// axios's own "Request failed with status code 400" beside it — twice — which names neither the
// search nor the reason, and "there is no lobby matching that" is not an error the player made.
export const thunk = createAsyncThunk("lobby/findLobby", async (data, { rejectWithValue }) => {
  try {
    const response = await apiClient.post("/lobby/find/", data, { handlesOwnErrors: true })
    return [response.data]
  } catch (error) {
    // Optional chaining for the same reason joinLobby has it: a request that never got an answer
    // has no `data`, and reading through it turned a dead server into a TypeError in the thunk.
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = lobbyReducers.setLobbies

const thunkObject = { thunk, onSucceed }
export default thunkObject
